export default __webpack_public_path__ + "static/media/Icon21.2fd28e29.png";